import { Fragment } from "react";
import "./CryptoExchange.css";
import { cryptoexchangeDevelopment } from "../../staticdata";
import cryptoexchangebanner from "../../assets/images/services/crypto/cryptoexchangebanner.jpg";


const CryptoExchange = () => {
  return (
    <Fragment>
      <section className="cryptoexchange-style">
        <div className="cryptoexchange-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="cryptoexchange-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Crypto Exchange Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  As a leading crypto exchange development company, we
                  specialize in building high-performance, scalable, and
                  compliant crypto exchange platforms tailored to
                  institutional-grade and enterprise-level needs. From
                  centralized ecosystems to AI-powered decentralized platforms,
                  each solution is engineered for scale, security, and strategic
                  growth.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={cryptoexchangebanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cryptoexchange-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Crypto Exchange Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {cryptoexchangeDevelopment.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="cryptoexchange-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default CryptoExchange;
